import { render, staticRenderFns } from "./PackageLimitAlertTestDialog.vue?vue&type=template&id=0efedcb5"
import script from "./PackageLimitAlertTestDialog.vue?vue&type=script&lang=js"
export * from "./PackageLimitAlertTestDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0efedcb5')) {
      api.createRecord('0efedcb5', component.options)
    } else {
      api.reload('0efedcb5', component.options)
    }
    module.hot.accept("./PackageLimitAlertTestDialog.vue?vue&type=template&id=0efedcb5", function () {
      api.rerender('0efedcb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/package_student/components/dialog/PackageLimitAlertTestDialog.vue"
export default component.exports